<template>
  <div class="text-center" v-if="partner()">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          variant="tonal"
          class="change-price-btn"
          :style="generalPriceRate != 0 ? 'border-color:red' : ''"
        >
          {{ $t("sidebar.rates") }}
        </v-btn>
      </template>
      <div class="container-change-price-tag">
        <div class="wrapper">
          <v-text-field
            :label="$t('sidebar.rate_input_label')"
            :value="generalPriceRate"
            v-model="generalPriceRate"
            type="number"
            prefix="%"
          ></v-text-field>
          <!-- <v-alert dense type="info" style="font-size: 12px">
            {{ $t("sidebar.rates_desc") }}
          </v-alert> -->
          <v-btn
            variant="tonal"
            @click="updateRate"
            style="width: 100%; margin-top: 1rem"
          >
            {{ $t("sidebar.rates_save") }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
export default {
  name: "ChangePriceTag",
  data() {
    return {
      generalPriceRate: 0,
      dialog: false,
    };
  },

  created() {
    this.getPartnerAndWriteStorage();
  },
  methods: {
    partner() {
      return (
        this.$store.state.GetServerData?.userType == "partner" &&
        this.$store.state.GetServerData
      );
    },
    async updateRate() {
      try {
        await axios.put(process.env.VUE_APP_API_URL + "admin/partner/rate", {
          generalPriceRate: this.generalPriceRate,
          partnerID: this.partner().partnerID,
          _id: this.partner()._id,
          type: "rate",
        });
        this.$store.dispatch({
          type: "successSwal",
          text: this.$t("alert.success", { name: this.$t("rate_name") }),
          refresh: false,
        });
        this.$store.commit("updateGeneralPriceRate", this.generalPriceRate);
        // window.localStorage.generalPriceRate = this.generalPriceRate;
      } catch (error) {
        Vue.swal.fire({
          icon: "error",
          showCloseButton: true,
          html: this.$t("alert.error", { name: this.$t("rate_name") }),
        });
      } finally {
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    },
    async getPartnerAndWriteStorage() {
      try {
        if (!this.partner()) {
          // window.localStorage.removeItem("generalPriceRate");
          this.$store.commit("updateGeneralPriceRate", 0);
          return;
        }
        const response = await axios.post(
          process.env.VUE_APP_API_URL + "admin/partner/rate",
          {
            _id: this.partner()._id,
          }
        );
        if (response?.data && response.data.length) {
          const partner = response.data[0];

          if (partner?.generalPriceRate) {
            this.generalPriceRate = partner?.generalPriceRate;
            this.$store.commit(
              "updateGeneralPriceRate",
              partner?.generalPriceRate
            );
            // window.localStorage.generalPriceRate = partner?.generalPriceRate;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss">
.change-price-btn {
  width: 90%;
  margin-bottom: 1rem;
  background-color: transparent !important;
  border: 1px solid white;
  color: white !important;
}
.container-change-price-tag {
  background-color: transparent !important;
  width: 100%;
  padding: 1rem 0.8rem;

  .wrapper {
    background-color: white !important;
    padding: 1rem;
    border-radius: 5px;
  }
}
</style>
